import { render, staticRenderFns } from "./PacienteFloatPanel.vue?vue&type=template&id=3bf24115&"
import script from "./PacienteFloatPanel.vue?vue&type=script&lang=js&"
export * from "./PacienteFloatPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports